import React, { FC } from "react"
import { Col, Row } from "react-bootstrap"

import { ReservedFields } from "@/onboarding/features/product/models/Product"
import Field from "@/onboarding/features/product/components/shared/Field"

const Content: FC = () => (
  <Row>
    <Col>
      <Field name={ReservedFields.START_LOCATION} label="Start Location" />
    </Col>
    <Col>
      <Field name={ReservedFields.TOUR_DURATION} label="Tour Duration (minutes)" />
    </Col>
  </Row>
)

export default Content
